import SectionGrid from './sections/SectionGrid'
import SectionHeroGrid from './sections/SectionHeroGrid'
import SectionGridItemsOnly from './sections/SectionGridItemsOnly'
import SectionPlain from './sections/SectionPlain'
import SectionImagePlain from './sections/SectionImagePlain'
import SectionCta from './sections/SectionCta'

const sectionDisplayModes = {
  SectionGrid: SectionGrid,
  SectionHeroGrid: SectionHeroGrid,
  SectionGridItemsOnly: SectionGridItemsOnly,
  SectionPlain: SectionPlain,
  SectionImagePlain: SectionImagePlain,
  SectionCta: SectionCta
}

const sectionForDisplayMode = (mode) => {

  let component

  if (mode) {
    component = sectionDisplayModes[mode]
  } else {
    component = SectionPlain
  }

  if ( !component ) {
    component = SectionPlain
    //throw new Error(`Section display-mode ${mode} not yet implemented`)
  }
  return component
}


export {
  sectionDisplayModes,
  sectionForDisplayMode,
  SectionGrid,
  SectionHeroGrid,
  SectionGridItemsOnly,
  SectionPlain,
  SectionImagePlain,
  SectionCta
}
